import React from 'react';

const MatchContinuationOverlay = ({ match, onConfirm, onCancel }) => {
  if (!match) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
        <h2 className="text-xl font-bold mb-4 text-center">Continue Match?</h2>
        <p className="mb-4 text-center">
          Do you want to continue the match against <span className="font-semibold">{match.opponent_name}</span> from {new Date(match.match_date).toLocaleDateString()}?
        </p>
        <div className="flex justify-around">
          <button
            onClick={() => onConfirm(match.match_id)}
            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
          >
            Yes, Continue
          </button>
          <button
            onClick={onCancel}
            className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
          >
            No, Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchContinuationOverlay;


